<template>
<div>
  <!-- Login Background  -->
  <div class="container-fluid stepsBar">
    <br>
    <br>
    <br>
    <div class="text-center ">
      <div class="loginRegSection" style="max-width: 400px; padding: 30px; margin: 0 auto;">
      <h2 class="mb-4">Reset Password</h2>
      <form class="userFormWrpr text-left mx-auto my-5" @submit.prevent="send"
        @keydown="form.onKeydown($event)" autocomplete="off">
        <label class="inputWrpr" :class="{ 'error': form.errors.has('email') ,'haveValue': form.email }">
          <input
          v-model="form.email"
          class="form-control"
          type="email"
          name="email"
          />
          <span class="label">Email</span>
          <has-error :form="form" field="email" class="errormsg"/>
        </label>
        <div class="form-group text-center mt-4">
          <input type="submit" value="Reset Now" class="btn btnSubmit">
        </div>
      </form>
      </div>
    </div>
  </div>
</div>
</template>

<script>

export default {
  name: "Reset_password",
  components: {

  },
  data() {
    return {
      form: new Form({
        email: "",
      }),
    };
  },

  methods: {
    async send() {
      await this.form.post("api/password/email").then((response) => {
        if (response.data.success == true) {
          this.form.reset();
          Toast.fire({
            icon: "success",
            title: response.data.message,
          });
        }
      });
    },
  },
};
</script>

<style scoped>
</style>
